/**
 * 节流函数
 * @param fn
 * @param wait
 * @returns {function(...[*]=)}
 */
function throttle (fn, wait = 500) {
  let timer
  return function (...args) {
    if (timer == null) { // undefined == null // true undefined === null //false 这里不要写成 严格相等 不然永远执行不进去
      timer = setTimeout(() => timer = null, wait)
      return fn.apply(this, args)
    }
  }
}

/**
 * 防抖函数
 * @param fn
 * @param wait
 * @returns {function(...[*]=)}
 */
function debounce (fn, wait = 500) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      return fn.apply(this, args)
    }, wait)
  }
}

/**
 * 获取cookie的某个key
 * @param name
 * @returns {string}
 */
function getCookieKey (name) {
  let strCookie = document.cookie
  let arrCookie = strCookie.split(';')
  let result = ''
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split('=')

    if (arr[0].trim() === name) {
      result = arr[1]
      break
    }
  }
  return result
}
/**
 * 获取每个 nav_box 盒子的高度
 * @param 
 * @returns {Array}
 */
 function getNavBox (item) {
  let topH = item + 15; //   上部分的高度
  let arr = document.getElementsByClassName('nav_box');
  let title = [] 
  for(let index= 0;index<arr.length;index++){
    title[index] = {height:arr[index].clientHeight,marginTop:index == 0? topH : title[(index - 1)].marginTop + title[(index - 1)].height}
  }
  return title
}

export {
  getNavBox,
  throttle,
  debounce,
  getCookieKey
}
